import { Box, useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import { Modal, ModalContent, ModalOverlay } from '~/components/ui/dialog'

interface FullScreenModalProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

const FullScreenModal: React.FC<FullScreenModalProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  const verticalMargin = useBreakpointValue(
    {
      base: '20px',
      sm: '40px',
      md: '40px',
      lg: '40px',
      xl: '60px',
    },
    { ssr: false },
  )

  const contentHeight = verticalMargin
    ? `calc(100vh - ${verticalMargin} * 2)`
    : '100%'

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        mx={verticalMargin}
        my={verticalMargin}
        maxWidth="1000px"
        minWidth="600px"
        width="100%"
        height={contentHeight}
        overflow="hidden"
        borderRadius="md"
        display="flex"
        flexDirection="column"
      >
        <Box
          flex="1"
          display="flex"
          flexDirection="column"
          minHeight={0}
          overflow="hidden"
        >
          {children}
        </Box>
      </ModalContent>
    </Modal>
  )
}

export default FullScreenModal
